import React, { useEffect, useState } from "react";
import { Button, Card } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import GetDetailsAns from "./getDetailsAns";
import GetVRFDetailsAns from "./getVRFDetailsAns";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "65%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  display: "block",
  // maxHeight: "70%",
  // overflowY: "auto",
  marginTop: "5rem",
  width: "50%",
  marginBottom: "40px"
};

function BusinessInformationStep1({ data, viewUrlData, changeScreen, vendorId, latestStepId }) {
  const [open, setOpen] = React.useState(false);
  const [detailsObjData, setDetailsObjData] = React.useState({ fieldsWithResponses: [] });
  const [isEditModal, setIsEditModal] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalData, setModalData] = React.useState({ fields: [] });

  const viewMedia = (data) => {
    viewUrlData(data);
  };

  useEffect(() => {
    setDetailsObjData(data);
  }, [data]);

  const openEditModal = (ele, index) => {
    let obj = { ...ele };
    obj.index = index
    setModalData(obj);
    setIsEditModal(true);
  }

  const handleCloseModal = () => {
    setIsEditModal(false);
    setModalData({ fields: [] });
  }

  return (
    <>
      <div className="">

        <div className="text-centers">
          {detailsObjData?.fieldsWithResponses.map((ele, i) => <>
            {(ele?.isModal == false) && <>
              <h5 className="vendor-details-sec-head">
                {ele?.sectionName}
              </h5>
              <Card className="vendor-details-card">
                <div className="">
                  <div className="row ">
                    {ele?.fields.map((childEle, j) => <>
                      {(childEle?.display == true) && <div className="col-sm-6">
                        <div className="row vendor-details-ele-row">
                          <div className="col-sm-5">
                            <h6 className="name_information_business_vendor_listing">
                              {childEle?.name}:
                            </h6>
                          </div>
                          <div className="col-sm-7 text-secondary lets_Technology_vendorlist">
                            <GetDetailsAns data={childEle} viewMedia={viewMedia} />
                          </div>
                        </div>
                      </div>}
                    </>)}
                  </div>
                </div>
              </Card>
            </>}

            {(ele?.isModal == true) && <>
              <div className="div-details-modal-btn">
                <button className="" onClick={() => openEditModal(ele, i)} >
                  {ele?.sectionName}
                </button>
                {(i == detailsObjData?.fieldsWithResponses?.length - 1) && <button className="div-details-modal-btn" onClick={() => changeScreen(true)}>
                  View Progress
                </button>}
              </div>
            </>}

          </>)}

        </div>
      </div>

      <Modal
        open={isEditModal}
        onClose={() => handleCloseModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style1} className="modal_react_controlpanel_employees">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="exampleModalLabel">
              Vendor Registration Form
            </h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              fdprocessedid="kum8iho"
              onClick={() => handleCloseModal(false)}
            ></button>
          </div>
          <div class="modal-body vrf-h-flow">
            <div class="vendor_registration_form">
              <div class="vendor_group">
                {
                  modalData?.fields?.map((ele) => (
                    <>
                      <div class="question">
                        {ele?.name}
                        {ele?.required && (
                          <span class="required">*</span>
                        )}
                      </div>

                      <div style={{ marginBottom: "10px" }}>
                        <GetVRFDetailsAns
                          data={ele}
                          viewMedia={viewMedia}
                        />
                        {/* <div className="select_react_user_details">
                                  <label class="mb-1 text-dark">
                                    Select Yes/No:
                                  </label>
                                  <p className="yes_react_detail_listing_vendor">
                                    Yes
                                  </p>
                                </div> */}
                      </div>
                    </>
                  ))}
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default BusinessInformationStep1;
